export const MIN_TABLE_SPLIT_SIZE = [140, 40]; // Минимальные размеры для сплита таблиц
export const MIN_MAP_SPLIT_SIZE = [25, 25]; // Минимальные размеры для сплита карты и таблиц


export const tablePropConfig = { scroll: { y: 'calc(100% - 30px)' } }; // общая настройка для таблиц
